import React from 'react';

export const name = 'trash';

export const Trash = () => (
  <svg xmlns="http://www.w3.org/2000/svg" color="#161619" viewBox="0 0 24 25">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 5.5V3H14.5V5.5H9.5ZM8 5.5V2.5C8 1.94772 8.44772 1.5 9 1.5H15C15.5523 1.5 16 1.94772 16 2.5V5.5H18.5H20H21.25C21.6642 5.5 22 5.83579 22 6.25C22 6.66421 21.6642 7 21.25 7H20V22.5C20 23.0523 19.5523 23.5 19 23.5H5C4.44772 23.5 4 23.0523 4 22.5V7H2.75C2.33579 7 2 6.66421 2 6.25C2 5.83579 2.33579 5.5 2.75 5.5H4H5.5H8ZM16 7H14.5H9.5H8H5.5V22H18.5V7H16Z"
      fill="currentColor"
      stroke="none"
    />
    <line
      x1="9.25"
      y1="10.75"
      x2="9.25"
      y2="18.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="14.75"
      y1="10.75"
      x2="14.75"
      y2="18.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
